/** @format */

import React from 'react';
import Button from 'src/ui/library/Button';
import Drawer from 'src/ui/library/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import Table from 'src/ui/library/Table';
import findIndex from 'lodash.findindex';
import { TableBuildForm, TableGetChildren, TableDeleteRowInParser, TableUpdateRowInParser } from '../../elements/TableFactoryHelpers';
import intl from 'react-intl-universal';

class HTComboTable extends React.Component {
  state = {
    rowIndex: null,
    showDelete: false,
    rowsSelected: [],
    popupFormChildren: null,
    popupFormElements: null,
    disableSaveButton: true,
  };

  tableFooter = () => {
    const { deleteRowsFn, cancelRowsFn } = this.props;
    const { rowsSelected, showDelete } = this.state;

    return (
      <section className="table-footer">
        {showDelete ? (
          <React.Fragment>
            <button onClick={() => {deleteRowsFn(rowsSelected, 'HTCombo'); this.isReloadPage();}} key="delete">
              {intl.get('controls.tables.delete')}
            </button>
            <button onClick={cancelRowsFn()} key="cancel">
              {intl.get('controls.tables.cancel')}
            </button>
          </React.Fragment>
        ) : (
          <button onClick={() => this.handleOpen('ADD')}>{intl.get('controls.tables.addRow')}</button>
        )}
      </section>
    );
  };

  handleClose = () => {
    const { popupFormElements } = this.state;

    // user has hit X without saving. remove the elements from the parser state
    TableDeleteRowInParser(popupFormElements, this.props.elementActions);
    // If form is changed and due to which complete page level form is incomplete
    // Now form (side drawer) is closed/cancelled without saving , then page level form state must be updated.
    // To update form state we have called onChange function and passed first element from side drawer form.
    this.props.elementActions().callOnChange(popupFormElements[0]);
    this.setState({ showPopup: false, actionType: null, rowIndex: null });
    this.props.refreshTableFn();
  };

  handleOpen = (actionType = null, defaultValues = {}) => {
    const { tableHeadElements, elementActions, readOnly } = this.props;
    let { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    if (tableElements && tableElements.length > 0 && tableElements[0].isEmptyRowColume) {
      // We dont need value for defaultEmptyColum
      Object.entries(defaultValues).forEach(([key, value], index) => {
        defaultValues[key] = null;
      });
    }
    const tableRowCount = tableElements.length / Object.keys(tableHeadElements).length;
    const { elements, children } = TableBuildForm(
      tableHeadElements,
      elementActions,
      tableRowCount,
      defaultValues,
      this.onDrawerClick,
      readOnly,
    );

    let isFormComplete = this.checkFormComplete(elements);

    this.setState({
      actionType,
      popupFormChildren: children,
      popupFormElements: elements,
      showPopup: true,
      disableSaveButton: !isFormComplete || readOnly,
    });
  };

  handleRemove = () => {
    const { popupFormElements, rowIndex } = this.state;
    const { tableHeadElements, elementActions } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    const { getParserState } = elementActions();

    const tableElementsIndex = tableElements.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});

    const { elements, logicIndex } = getParserState();
    let elementsToRemove = [];

    popupFormElements.forEach(el => {
      const index = tableElementsIndex[el.id];
      const tableEl = tableElements[index];

      const positions = logicIndex[tableEl.logicId];

      positions.forEach(position => {
        let currentEl = elements[position];
        if (currentEl.rowIndex === rowIndex) {
          elementsToRemove.push({
            rowIndex: currentEl.rowIndex,
            origRowIndex: currentEl.rowIndex,
            isRowSelected: true,
          });
        }
      });
    });

    this.props.deleteRowsFn([elementsToRemove[0]]);

    this.setState({
      actionType: null,
      popupFormElements: null,
      popupFormChildren: null,
      showPopup: false,
    });
  };

  handleSave = () => {
    const { popupFormElements, rowIndex } = this.state;
    let { actionType } = this.state;
    const { tableHeadElements, elementActions, addNewRowFn, tableHeadOrder, tableActions } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    let updatedRowIndex = rowIndex;
    const { removeEmptyRowFromTableFormValues } = elementActions();
    //Code to remove first empty row.
    const rowColumnsLength = Object.keys(tableHeadElements).length;
    let deleteRowIndex = 0;

    let isFirstRowEmpty = true;
    let isCheckboxTicked = false;
    const parentId = tableElements[0].parentId;
    for (let i = 0; i < rowColumnsLength; i++) {
      if (tableElements[i].controlTypeName === 'CheckBox') {
        isCheckboxTicked = isCheckboxTicked || tableElements[i].props.value.toLowerCase() === 'true' ? true : false;
      } else if (
        tableElements[i].props.value !== null &&
        tableElements[i].props.value !== undefined &&
        tableElements[i].props.value !== ''
      ) {
        isFirstRowEmpty = false;
        break;
      } else {
        deleteRowIndex = tableElements[i].origRowIndex != null ? tableElements[i].origRowIndex : updatedRowIndex;
      }
    }
    isFirstRowEmpty = !isCheckboxTicked && isFirstRowEmpty;
    if (isFirstRowEmpty) {
      tableElements.splice(0, rowColumnsLength);
      updatedRowIndex = updatedRowIndex != null ? updatedRowIndex : 0;
      removeEmptyRowFromTableFormValues(parentId, deleteRowIndex);
      actionType = 'EDIT';
    }
    //  Code to remove first empty row ends here.

    const tableElementsIndex = tableElements.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});

    TableDeleteRowInParser(popupFormElements, elementActions);

    if (actionType === 'EDIT') {
      const rowValues = popupFormElements.reduce((acc, next) => {
        const index = tableElementsIndex[next.id];
        const elValue = tableElements[index].props.value;
        acc[next.logicId] = elValue;
        return acc;
      }, {});

      TableUpdateRowInParser(
        rowValues,
        updatedRowIndex,
        elementActions,
        tableHeadElements,
        tableHeadOrder,
        tableActions,
        isFirstRowEmpty,
        'HTCombo',
      );
      this.props.refreshTableFn();

      const { callOnChange } = elementActions();
      callOnChange(this.props.id);
    } else {
      const rowValues = popupFormElements.map(el => {
        const index = tableElementsIndex[el.id];
        const elValue = tableElements[index].props.value;
        return elValue;
      });

      addNewRowFn(rowValues, false, 'HTCombo');
    }

    this.setState({
      actionType: null,
      popupFormElements: null,
      popupFormChildren: null,
      showPopup: false,
    });

    this.isReloadPage();
  };

  isReloadPage = () => {
    if(this.props.reloadPage === true && typeof this.props.actions.saveQuestionnaire === "function"){
      this.props.actions.forceDisableSubmitBtn(true);
      this.props.toggleReloadPage();
      let isFormComplete = true;
      this.props.actions.saveQuestionnaire(() => {
        this.props.actions.forceDisableSubmitBtn(false);
      }, isFormComplete);
    }
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'cellClick') {
      const { origRowIndex } = data.cellClicked;

      const { tableHeadElements, elementActions } = this.props;
      const { tableElements } = TableGetChildren(tableHeadElements, elementActions);

      const tableRowMap = tableElements.reduce((acc, next) => {
        if (next.rowIndex === origRowIndex) {
          acc[next.logicId] = next.props.value;
        }
        return acc;
      }, {});

      this.setState({ rowIndex: origRowIndex }, () => this.handleOpen('EDIT', tableRowMap));
      const { selectedRows } = data.model;
      let selectedRestRows = selectedRows.filter(row => {
        return row.origRowIndex !== origRowIndex;
      });

      this.setState({
        showDelete: selectedRestRows.length > 0,
        rowsSelected: selectedRestRows,
      });
    }

    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length > 0,
        rowsSelected: selectedRows,
      });
    }
  };

  checkFormComplete = (popupFormElementsParam = null) => {
    let isFormComplete = true;
    const popupFormElements = this.state.popupFormElements || popupFormElementsParam;
    const { tableHeadElements, elementActions } = this.props;
    const { tableElements } = TableGetChildren(tableHeadElements, elementActions);
    const tableElementsIndex = tableElements.reduce((acc, next, index) => {
      acc[next.id] = index;
      return acc;
    }, {});
    /* check all regular page elements that are required are filled out */
    if (popupFormElements) {
      for (let index = 0; index < popupFormElements.length; index++) {
        const elementId = tableElementsIndex[popupFormElements[index].id];
        if (!elementId) {
          return;
        }
        const element = tableElements[elementId];
        const { required, isComponentVisible, controlTypeName, value } = element.props;
        if (required && isComponentVisible) {
          if (controlTypeName === 'DropDown' || controlTypeName === 'CountryList') {
            if (this.checkDownDropComplete(element)) {
              isFormComplete = this.checkDownDropComplete(element);
            } else {
              isFormComplete = false;
              break;
            }
          }
          //modified to incorporate checkbox value which is "false" if not selected
          if (value === '' || value === null || (typeof value === 'string' && value.toLowerCase() === 'false')) {
            isFormComplete = false;
            break;
          }
        }
      }
    } else {
      isFormComplete = false;
    }
    return isFormComplete;
  };

  checkDownDropComplete = el => {
    const { props } = el;
    const lookUpIndex = findIndex(props.listOptions, item => item.displayText === '(Select)');

    if (lookUpIndex !== -1) {
      return props.listOptions[lookUpIndex].lookUpBindValue === props.value ? false : true;
    }

    return true;
  };

  onDrawerClick = () => {
    const enableSave = this.checkFormComplete();
    this.setState({ disableSaveButton: !enableSave });
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      elementActions,
      deleteRowsFn,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;

    return (
      <div className={'horizontal-table'}>
        <span className={'table-label'}>{label}</span>
        <Drawer
          open={this.state.showPopup}
          anchor={'right'}
          styleType={'questionnaire'}
          isMobile={false}
          topFixed={true}
          onClose={this.handleClose}
          onChange={this.onDrawerClick}
          onBlur={this.onDrawerClick}>
          <section className={'htcombo-popup-wrapper'}>
            <div className={'popup-title-wrapper'}>
              <h2 className={'title-text'}>{label}</h2>
              <button className="title-action" onClick={this.handleClose}>
                <CloseIcon />
              </button>
            </div>

            <div className={'popup-form'}>
              {this.state.popupFormChildren}
              <div className={'htcombo-actions'}>
                <div className={'button-wrapper'}>
                  <Button styleType={'secondary'} className={'action-button'} onClick={this.handleClose}>
                    {intl.get('default.label.cancel')}
                  </Button>
                  <Button className={'action-button'} disabled={this.state.disableSaveButton} onClick={this.handleSave}>
                    {intl.get('default.label.save')}
                  </Button>
                </div>
                {this.state.actionType === 'EDIT_SUPPRESS' && (
                  <div className={'remove-wrapper'}>
                    <a onClick={this.handleRemove} className={'ey-link'}>
                      Remove
                    </a>
                  </div>
                )}
              </div>
            </div>
          </section>
        </Drawer>
        <Table
          footer={this.tableFooter}
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
          hardDisplay={false}
        />
      </div>
    );
  }
}

export default HTComboTable;
